var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessOffer8Ball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,6A18,18 0,1 0,24,42A18,18 0,1 0,24,6",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,8A16,16 0,1 0,24,40A16,16 0,1 0,24,8",
    fill: "#0D0D12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,16A7.2,7.2 0,1 0,24,30.4A7.2,7.2 0,1 0,24,16",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,27.5v-8.7h4.4c2.6,0 4,1.1 4,3c0,1.1 -0.5,1.9 -1.5,2.4c1.3,0.5 1.9,1.4 1.9,2.8c0,2.1 -1.6,3.4 -4.3,3.4h-4.5zm2.6,-5.3h1.4c1.1,0 1.8,-0.5 1.8,-1.3c0,-0.8 -0.6,-1.2 -1.7,-1.2h-1.5v2.5zm0,3.5h1.7c1.2,0 1.9,-0.5 1.9,-1.4c0,-0.9 -0.7,-1.4 -1.9,-1.4h-1.7v2.8z",
    fill: "#0D0D12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessOffer8Ball);
export default __webpack_public_path__ + "static/media/p4r_business_offer_8ball.d1500650d7c7d9d0263fbe4b51f137fd.svg";
export { ForwardRef as ReactComponent };